export default "__VITE_ASSET__b4ce075e__"